<!-- 委托tab -->
<template>
    <div id="agentEntrustTab">
        <b-tabs class="tab-header" v-model="tabIndexHeader" pills card>
            <!-- 普通订单 -->
            <b-tab :title="$t('entrustedList.tabTxt15')">
                <EntrustedList />
            </b-tab>
            <!-- <b-tab
          :title="$t('entrustedList.tabTxt16')"
        >
          条件单
          <ConditionList />
        </b-tab> -->
        </b-tabs>
    </div>
</template>
<script>
import EntrustedList from "./agentEntrustList";
import ConditionList from "./agentConditionList";
export default {
    name: "liquidationListTab",
    components: { EntrustedList, ConditionList },
    data() {
        return {
            tabIndexHeader: 0,
        };
    },
};
</script>
<style lang="scss">
#agentEntrustTab {
    .tab-header {
        .card-header {
            border-radius: 16px 16px 0px 0px !important;

            // padding-left: 5px !important;
            // padding-right: 5px !important;
            .nav {
                padding-bottom: 10px !important;
                border-bottom: 1px solid #ebebeb;
                margin: 0 0px;
                margin-top: 12px;

                .nav-item {
                    position: relative;
                    left: -18px;
                }
            }
        }

        .tab-content {
            border-radius: 0px 0px 16px 16px !important;
            background: #F3F6FA !important;

            .tab-pane {
                padding: 0px !important;
            }
        }
    }
}
</style>